<template>
    <b-container class="processStep">
        <b-row class="processStepFlex" :id="'processStep'+number">
            <b-col lg="6" sm="12">
                <img :src="getImg(img)" :alt="title">
            </b-col>
            <b-col lg="6" sm="12" class="processStepContent">
                <h2>{{title}}</h2>
                <p class="pink bold">{{subtitle}}</p>
                <p>{{description}}</p>
                <ul>
                    <li v-for="(li, i) in list" :key="i">+ {{li}}</li>
                </ul>
            </b-col>
        </b-row>
        <hr :id="'hrProcess'+number">
    </b-container>
</template>

<script>
export default {
    name: "processStep",
    props: {
        title: String,
        subtitle: String,
        description: String,
        list: Array,
        img: String,
        alt: String,
        number: Number
    },
    methods: {
        getImg: function(img) {
            return require('@/assets/imagesTech/'+img)
        }
    }
}
</script>

<style style="scss" scoped>
img {width:100%;}

ul {
    padding-inline-start: 0px;
}

li {
    padding: 5px 0;
}

.processStepContent{
    padding: 0 30px;
}

.processStepFlex{
    display:flex;
    justify-content: space-between;
    align-items: flex-start;
}

#processStep1 {
    flex-direction: row-reverse;
}

#hrProcess2{
    display:none;
}

@media (max-width:991px) {
    img {
        margin-bottom:50px;
        width:80%;
        margin-left:10%;
    }
}
</style>